import * as Yup from "yup";
import { IMPACT_SUM_MAX_MESSAGE } from "../utils/scoringConfigFormValidation";
import {
  noSpecialCharsYupTest,
  SPECIAL_CHARS_VALIDATION_MESSAGE,
} from "../utils/inputValidation";

export const addEditDomainSchema = Yup.object({
  domain_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter domain name"),
  domain_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter domain code"),
  domain_desc: Yup.string().test(
    "no-special-chars",
    SPECIAL_CHARS_VALIDATION_MESSAGE,
    noSpecialCharsYupTest,
  ),
  domain_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});
export const executionNameSchema = Yup.object({
  execution_name: Yup.string().required("Execution Name is required"),
});

export const addEditResourceSchema = Yup.object({
  domain_id: Yup.string().required("Domain is required"),
  resource_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource name is required"),
  resource_prefix: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource prefix is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Code is required"),
  resource_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
  resource_type: Yup.string().required("Resource type is required"),
  system_id: Yup.number().required("Please select system"),
  resource_column_details_id: Yup.string().required(
    "Resource Column is required",
  ),
  linked_service: Yup.object().required("Connection Type is required"),
});
export const addResourceCombinedColumnSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Resource Column Details Name"),
  resource_column_details_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Resource Column Details Code"),
});
export const addNewResourceWithoutLinkedServiceSchema = Yup.object({
  domain_id: Yup.string().required("Domain is required"),
  resource_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource name is required"),
  resource_prefix: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource prefix is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Code is required"),
  resource_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
  resource_type: Yup.string().required("Resource type is required"),
  system_id: Yup.number().required("Please select system"),
});
export const addNewResourceSchema = Yup.object({
  ...addNewResourceWithoutLinkedServiceSchema.fields,
  linked_service: Yup.object().required("Connection Type is required"),
});
export const addNewResourceNewDomainWithoutLinkedServiceSchema = Yup.object({
  domain_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter domain code"),
  domain_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter domain name"),
  resource_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource name is required"),
  resource_prefix: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource prefix is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Code"),
  resource_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
  resource_type: Yup.string().required("Resource type is required"),
  system_id: Yup.number().required("Please select system"),
});
export const addNewResourceNewDomainSchema = Yup.object({
  ...addNewResourceNewDomainWithoutLinkedServiceSchema.fields,
  linked_service: Yup.object().required("Connection Type is required"),
});

export const addResourceWithNewDomainWithSampleData = Yup.object().shape({
  ...addNewResourceNewDomainSchema.fields,
  ...addResourceCombinedColumnSchema.fields,
});

export const addResourceWithExistingDomainWithSampleData = Yup.object().shape({
  ...addNewResourceSchema.fields,
  ...addResourceCombinedColumnSchema.fields,
});

export const addResourceColumnDetailsSchema = Yup.object({
  resource_column_details_id: Yup.number().required(
    "Resource Column is required",
  ),
});
export const editResourceColumnSchema = Yup.object({
  resource_column_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource column name is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource code is required"),
  resource_column_details_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});

export const aggregatedValidateSchema = Yup.object({
  base_resource_id: Yup.string().required("Base Resource is required"),
  aggregation_query: Yup.string().required("Aggregation Query is required"),
  base_resource_columns: Yup.array().required(
    "Base Resource Columns is required",
  ),
});
export const aggregatedResourceValidateSchema = Yup.object({
  base_resource_id: Yup.string().required("Base Resource is required"),
  aggregation_query: Yup.string().required("Aggregation Query is required"),
  base_resource_columns: Yup.array().required(
    "Base Resource Columns is required",
  ),
});
export const reRunResourceValidateSchema = Yup.object({
  base_resource_id: Yup.string().required("Base Resource is required"),
  aggregation_query: Yup.string().required("Aggregation Query is required"),
  base_resource_columns: Yup.array().required(
    "Base Resource Columns is required",
  ),
  system_id: Yup.number().required("System is required"),
  linked_service: Yup.object().required("Connection Type is required"),
  resource_definition: Yup.object().shape({
    connection_key: Yup.mixed().required("Connection Key is required"),
  }),
});

export const localDefinitionSchema = Yup.object().shape({
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  resource_definition: Yup.object().shape({
    resource_path: Yup.string().required("Resource Path is required"),
    connection_key: Yup.string().required("Connection Key is required"),
  }),
});

export const blobDefinitionSchema = Yup.object().shape({
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  resource_definition: Yup.object().shape({
    connection_key: Yup.number().required("Connection Key is required"),
    container_name: Yup.string().required("Container Name is required"),
    resource_path: Yup.string().required("Resource Path is required"),
  }),
});

export const sftpDefinitionSchema = Yup.object().shape({
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  resource_definition: Yup.object().shape({
    connection_key: Yup.number().required("Connection Key is required"),
    remote_directory: Yup.string().required("Remote Directory is required"),
  }),
});

export const sqlDefinitionSchema = Yup.object().shape({
  resource_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    sql_query: Yup.string()
      .required("SQL Query is required")
      .test(
        "contains-only-spaces",
        "SQL Query cannot contain only spaces",
        (value) => {
          if (value === "") {
            return true;
          } else {
            const containsOnlySpaces = !/\S/.test(value); // Check for only spaces
            return !containsOnlySpaces;
          }
        },
      ),
    column_name_to_partition_on_sql_query: Yup.string().when(
      ["use_multi_thread_reader"],
      {
        is: (use_multi_thread_reader: boolean) =>
          use_multi_thread_reader === true,
        then: () =>
          Yup.string().required(
            "Column name to partition on is required when multi-thread reader is enabled",
          ),
        otherwise: () => Yup.string().nullable(),
      },
    ),
  }),
  use_multi_thread_reader: Yup.boolean(),
});
export const filterRulesNameSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Name is required"),
});
export const filterRulesSqlSchema = Yup.object().shape({
  sql_query: Yup.string().required("SQL Query is required"),
  //.max(255, "SQL Query must be at most 200 characters"),
});

export const multipleGridListSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Name is required"),
  sql_query: Yup.string().required("SQL Query is required"),
  //.max(255, "SQL Query must be at most 200 characters"),
});

export const internalReferenceSchema = Yup.object().shape({
  source_type: Yup.string().required("Source Type is required"),
});
export const externalReferenceSchema = Yup.object().shape({
  source_type: Yup.string().required("Source Type is required"),
  connection_key: Yup.object().required("Connection key is required"),
  linked_service: Yup.object().required("Connection Type is required"),
});

export const showConsolidateReportSchema = Yup.object().shape({
  run_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Execution group name is required"),
  report_type: Yup.string().required("Report type is required"),
});
export const executionHistorySearchSchema = Yup.object().shape({
  search_query: Yup.string().required("Search value is required"),
});

export const toleranceSchema = Yup.object().shape({
  tolerance_value: Yup.string().required("Tolerance value is required"),
  tolerance_type: Yup.string().required("Tolerance type is required"),
});
export const toleranceWithFallbackSchema = Yup.object().shape({
  ...toleranceSchema.fields,
  fallback_value: Yup.string().required("Fallback value is required"),
});
export const addResourceColumnDetailSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Resource Column Details Name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Code"),
  domain_id: Yup.string().required("Please select domain"),
  resource_column_details_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});
export const addResourceNewColumnSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Resource Column Details Name"),
  domain_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Domain Code"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Code"),
  domain_id: Yup.string().required("Please select domain"),
  resource_column_details_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});
export const addEditRuleSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Rule Name.")
    .max(50, "Rule name cannot exceed 50 characters"),
  domain_id: Yup.string().required("Please select domain"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Code"),
  rule_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
  secondaryResource: Yup.array().of(
    Yup.object().shape({
      resource_id: Yup.mixed()
        .required("Please select secondary resource")
        .nullable()
        .test(
          "resource-id-validation",
          "Please select secondary resource",
          (value) => value !== null && value !== undefined,
        ),

      resource_columns: Yup.array()
        .of(Yup.string())
        .min(1, "Please select at least one resource column")
        .test(
          "no-blank-values",
          "Resource columns cannot be empty or contain 'blank'",
          (columns) => {
            return (
              Array.isArray(columns) &&
              columns.every((col) => col?.trim() !== "")
            );
          },
        )
        .required("Please select resource columns"),
    }),
  ),
});
export const derivedColumnSchema = Yup.object().shape({
  column_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter column name"),
  query: Yup.string().required("Please enter query"),
});
export const customValidationSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  expression: Yup.string()
    .required("Please enter query")
    .test(
      "contains-only-spaces",
      "Query cannot contain only spaces",
      (value) => {
        if (value === "") {
          return true;
        } else {
          const containsOnlySpaces = !/\S/.test(value); // Check for only spaces
          return !containsOnlySpaces;
        }
      },
    ),
});
export const additionalResourceSchema = Yup.object().shape({
  resource_id: Yup.string().required("Please select resource"),
  base_column_names: Yup.array()
    .min(1, "Please select base_column_names")
    .required("Please select base_column_names"),
  add_on_column_names: Yup.array()
    .min(1, "Please select add_on_column_names")
    .required("Please select add_on_column_names"),
  merge_type: Yup.string().required("Please select merge type"),
});

export const cloneResForViewRes = Yup.object().shape({
  resource_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Name is required"),
  //resource_type: Yup.string().required("Resource type is required"),
  resource_prefix: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Prefix is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Code is required"),
  resource_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});
export const cloneResForViewResAndResColSchema = Yup.object().shape({
  ...cloneResForViewRes.fields,
  resource_column_details_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Column Details Name is required"),
  resource_column_details_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Column Code is required"),
});
export const cloneResourceSchema = Yup.object().shape({
  domain_id: Yup.string().required("Domain is required"),
  resource_id: Yup.string().required("Resource is required"),
  ...cloneResForViewRes.fields,
});

export const cloneResourceColumnSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Column Details Name is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Column Code is required"),
  resource_column_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});

export const cloneResourceAndResourceColumnSchema = Yup.object().shape({
  ...cloneResourceSchema.fields,
  resource_column_details_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Column Details Name is required"),
  resource_column_details_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Resource Column Code is required"),
});

export const cloneDomainSchema = Yup.object().shape({
  domain_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Domain Name is required"),
  domain_code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Domain Code is required"),
  domain_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});

export const cloneGenericResearchQuerySchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Research Query Name is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Research Query Code is required"),
  generic_research_query_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});

export const cloneComparisonResearchQuerySchema = Yup.object().shape({
  rule_id: Yup.number()
    .nullable()
    .required("Please select a Rule")
    .typeError("Please select a Rule"),
});

export const cloneRuleSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Rule Name is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Rule Code is required"),
  rule_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
});

export const addEditLinkedServiceSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  sub_type: Yup.string().required("Please enter sub type"),
  connection_keys: Yup.array().required("Please select connection key"),
});

export const addEditConnectionKeySchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  system_id: Yup.number().required("Please select system"),
  ip_address: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter ip address"),
  user_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter user name"),
  password: Yup.string().required("Please enter password"),
  connection_string: Yup.string().required("Please enter connection string"),
  api_client_id: Yup.string().required("Please enter api client id"),
  api_secret: Yup.string().required("Please enter api secret"),
  api_token: Yup.string().required("Please enter api token"),
  api_url: Yup.string()
    .required("Please enter api url")
    .test("valid-url", "Please enter a valid api url", (value) => {
      if (!value) {
        return false;
      }
      const urlPattern =
        /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
      return urlPattern.test(value);
    }),

  azure_tenant_id: Yup.string().required("Please enter azure tenant id"),
  azure_client_id: Yup.string().required("Please enter azure client id"),
  azure_client_secret: Yup.string().required(
    "Please enter azure client secret",
  ),
  token: Yup.string().required("Please enter token"),
  api_key: Yup.string().required("Please enter api key"),
});
export const addEditConnectionKeySqlSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  system_id: Yup.number().required("Please select system"),
  connection_string: Yup.string().required("Please enter connection string"),
});
export const addEditConnectionKeyBlobSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  system_id: Yup.number().required("Please select system"),
  connection_string: Yup.string().required("Please enter connection string"),
});
export const addEditConnectionKeySftpSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  system_id: Yup.number().required("Please select system"),
  ip_address: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter ip address"),
  user_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter user name"),
  password: Yup.string().required("Please enter password"),
});
export const addEditConnectionKeyApiSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  system_id: Yup.number().required("Please select system"),
  api_url: Yup.string()
    .required("Please enter api url")
    .test("valid-url", "Please enter a valid api url", (value) => {
      if (!value) {
        return false;
      }
      const urlPattern =
        /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
      return urlPattern.test(value);
    }),
});

// Unified schema for AddConnectionKey with conditional validation based on connection type
export const addEditConnectionKeyUnifiedSchema = Yup.object({
  // Common fields required for all types
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  type: Yup.string().required("Please enter type"),
  system_id: Yup.number().required("Please select system"),

  // SFTP-specific fields
  ip_address: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .when("type", {
      is: "sftp",
      then: (schema) => schema.required("Please enter ip address"),
      otherwise: (schema) => schema.notRequired(),
    }),
  user_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .when("type", {
      is: "sftp",
      then: (schema) => schema.required("Please enter user name"),
      otherwise: (schema) => schema.notRequired(),
    }),
  password: Yup.string().when("type", {
    is: "sftp",
    then: (schema) => schema.required("Please enter password"),
    otherwise: (schema) => schema.notRequired(),
  }),
  connection_runtime_config_id: Yup.number().when("type", {
    is: "sftp",
    then: (schema) =>
      schema
        .required("Please select a connection runtime config")
        .typeError("Connection runtime config must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // SQL-specific fields (for mariadb, azure_sql, oracle_sql, snowflake_sql, postgres_sql, azure_sql_service_principal)
  connection_string: Yup.string().when("type", {
    is: (value: string) =>
      [
        "mariadb",
        "azure_sql",
        "oracle_sql",
        "snowflake_sql",
        "postgres_sql",
        "azure_sql_service_principal",
        "blob",
      ].includes(value),
    then: (schema) => schema.required("Please enter connection string"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // API-specific fields
  api_url: Yup.string().when("type", {
    is: (value: string) =>
      [
        "no_auth_api",
        "basic_auth_api",
        "token_auth_api",
        "key_auth_api",
        "oauth_api",
      ].includes(value),
    then: (schema) =>
      schema
        .required("Please enter api url")
        .test("valid-url", "Please enter a valid api url", (value) => {
          if (!value) {
            return false;
          }
          const urlPattern =
            /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
          return urlPattern.test(value);
        }),
    otherwise: (schema) => schema.notRequired(),
  }),

  // Token and API Key for specific auth types
  token: Yup.string().when("type", {
    is: (value: string) => ["token_auth_api"].includes(value),
    then: (schema) => schema.required("Please enter token"),
    otherwise: (schema) => schema.notRequired(),
  }),
  api_key: Yup.string().when("type", {
    is: (value: string) => ["key_auth_api"].includes(value),
    then: (schema) => schema.required("Please enter api key"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // Azure SQL Service Principal fields
  azure_client_id: Yup.string().when("type", {
    is: "azure_sql_service_principal",
    then: (schema) => schema.required("Please enter azure client id"),
    otherwise: (schema) => schema.notRequired(),
  }),
  azure_client_secret: Yup.string().when("type", {
    is: "azure_sql_service_principal",
    then: (schema) => schema.required("Please enter azure client secret"),
    otherwise: (schema) => schema.notRequired(),
  }),
  azure_tenant_id: Yup.string().when("type", {
    is: "azure_sql_service_principal",
    then: (schema) => schema.required("Please enter azure tenant id"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const addEditRunInstanceSchema = Yup.object({
  run_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter execution group name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
});

export const addEditExecutionSubGroupSchema = Yup.object({
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code")
    .matches(/^\S+$/, "Code must not contain whitespace"),
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter name"),
});
export const addEditSystemSchema = Yup.object({
  value: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("System Name is required"),
});

export const addEditIssueClassificationSchema = Yup.object({
  issue_classification_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Classification Name is required"),
  is_active: Yup.boolean().optional(),
});

export const addEditIssueReasonSchema = Yup.object({
  issue_classification_id: Yup.number()
    .required("Classification is required")
    .min(1, "Classification is required"),
  reason_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Reason Name is required"),
  is_active: Yup.boolean().optional(),
});

export const addRunInstanceFromExecutionSchema = Yup.object({
  run_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter execution group name"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter execution group name"),
});

export const addExecutionSubGroupFromExecutionSchema = Yup.object({
  execution_sub_group_code: Yup.string().required(
    "Please enter sub group code",
  ),
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter sub group name"),
});

export const addEditConnectionRuntimeConfigSchema = Yup.object({
  connection_type: Yup.string().required("Please select connection type"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter code"),
  max_file_download_threads: Yup.number().nullable(),
  max_chunk_download_threads: Yup.number().nullable(),
  chunk_threshold_size_in_bytes: Yup.number().nullable(),
  max_num_of_file_chunk: Yup.number().nullable(),
  max_num_of_service_conn: Yup.number().nullable(),
});

export const addEditFileProcessingSchema = Yup.object({
  resource_type: Yup.string().required("Please enter Resource Type"),
  // file_format: Yup.string().required("Please enter File Format"),
  // schema_definition: Yup.string().required("Please enter Schema Definition"),
  // field_delimiter: Yup.string().required("Please enter Field Delimiter"),
  // type: Yup.string().required("Please enter Type"),
  // store_name: Yup.string().required("Please enter Store Name"),
  // store_label: Yup.string().required("Please enter Store Label"),
  // footer_lines: Yup.number().required("Please enter Footer Lines"),
  // header_lines: Yup.number().required("Please enter Header Lines"),
  // skip_rows: Yup.number().required("Please enter Skip Rows"),
  // compression: Yup.string().required("Please enter Compression"),
  // compression_codec: Yup.string().required("Please enter Compression Codec"),
  // line_terminator: Yup.string().required("Please enter Line Terminator"),
  // has_comments: Yup.string().required("Please enter Has Comments"),
  // comments_marker: Yup.string().required("Please enter Comments Marker"),
  // encoding: Yup.string().required("Please enter Encoding"),
  // bad_lines: Yup.string().required("Please enter Bad Lines"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Please enter Code"),
});

export const localLinkedServiceSchema = Yup.object().shape({
  system_id: Yup.number().required("System is required"),
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  linked_service: Yup.object().required("Connection Type is required"),
  resource_definition: Yup.object().shape({
    resource_path: Yup.string().required("Resource Path is required"),
    connection_key: Yup.string().required("Connection Key is required"),
    column_delimiter: Yup.string().required("Column Delimiter is required"),
    file_name: Yup.string().required("File Name is required"),
    // excel_sheet_name: Yup.string(),
  }),
});

export const blobLinkedServiceSchema = Yup.object().shape({
  system_id: Yup.number().required("System is required"),
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  linked_service: Yup.object().required("Connection Type is required"),
  resource_definition: Yup.object().shape({
    connection_key: Yup.number().required("Connection Key is required"),
    container_name: Yup.string().required("Container Name is required"),
    resource_path: Yup.string().required("Resource Path is required"),
    column_delimiter: Yup.string().required("Column Delimiter is required"),
    file_name: Yup.string().required("File Name is required"),
    // excel_sheet_name: Yup.string(),
  }),
});

export const sftpLinkedServiceSchema = Yup.object().shape({
  system_id: Yup.number().required("System is required"),
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  linked_service: Yup.object().required("Connection Type is required"),
  resource_definition: Yup.object()
    .shape({
      connection_key: Yup.number().required("Connection Key is required"),
      remote_directory: Yup.string(),
      resource_path: Yup.string(),
      column_delimiter: Yup.string().required("Column Delimiter is required"),
      file_name: Yup.string().required("File Name is required"),
      // excel_sheet_name: Yup.string(),
    })
    .test(
      "sftp-path-required",
      "Remote Directory or Resource Path is required",
      (value) => {
        const remoteDirectory = value?.remote_directory?.trim();
        const resourcePath = value?.resource_path?.trim();
        return Boolean(remoteDirectory || resourcePath);
      },
    ),
});

export const sqlLinkedServiceSchema = Yup.object().shape({
  system_id: Yup.number().required("System is required"),
  linked_service: Yup.object().required("Connection Type is required"),
  resource_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    sql_query: Yup.string()
      .required("SQL Query is required")
      .test(
        "contains-only-spaces",
        "SQL Query cannot contain only spaces",
        (value) => {
          if (value === "") {
            return true;
          } else {
            const containsOnlySpaces = !/\S/.test(value); // Check for only spaces
            return !containsOnlySpaces;
          }
        },
      ),
  }),
});

export const addNewVariableSchema = Yup.object().shape({
  var_name: Yup.string()
    .required("Name is required")
    .matches(
      /^[a-zA-Z0-9_]+$/,
      "Variable Name can only contain alphabets, numbers, and underscores.",
    ),
  var_value: Yup.string().required("Value is required"),
});

export const basicAuthApiDefinitionSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      user_name: Yup.string().required("Username is required"),
      password: Yup.string().required("Password is required"),
      url: Yup.string().required("Url is required"),
      request_timeout: Yup.string().required("Request Timeout is required"),
    }),
  }),
});

export const tokenAuthApiDefinitionSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      bearer_token: Yup.string().required("Bearer Token is required"),
      url: Yup.string().required("Url is required"),
      request_timeout: Yup.string().required("Request Timeout is required"),
    }),
  }),
});

export const keyAuthApiDefinitionSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      api_key: Yup.string().required("Api Key is required"),
      url: Yup.string().required("Url is required"),
      request_timeout: Yup.string().required("Request Timeout is required"),
    }),
  }),
});

export const oAuthApiDefinitionSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      oauth_client_id: Yup.string().required("Oauth Client Id is required"),
      oauth_client_secret: Yup.string().required(
        "Oauth Client Secret is required",
      ),
      oauth_url: Yup.string().required("Oauth Url is required"),
      url: Yup.string().required("Url is required"),
      request_timeout: Yup.string().required("Request Timeout is required"),
    }),
  }),
});
export const noAuthApiDefinitionSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      url: Yup.string().required("Url is required"),
      request_timeout: Yup.string().required("Request Timeout is required"),
    }),
  }),
});

export const basicAuthApiSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      user_name: Yup.string()
        .test(
          "no-special-chars",
          SPECIAL_CHARS_VALIDATION_MESSAGE,
          noSpecialCharsYupTest,
        )
        .required("Username is required"),
      password: Yup.string().required("Password is required"),
    }),
  }),
});

export const tokenAuthApiSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      bearer_token: Yup.string().required("Bearer Token is required"),
    }),
  }),
});

export const keyAuthApiSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      api_key: Yup.string().required("Api Key is required"),
    }),
  }),
});

export const oAuthApiSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
      oauth_client_id: Yup.string().required("Oauth Client Id is required"),
      oauth_client_secret: Yup.string().required(
        "Oauth Client Secret is required",
      ),
      oauth_url: Yup.string().required("Oauth Url is required"),
    }),
  }),
});

export const noAuthApiSchema = Yup.object({
  resource_definition: Yup.object().shape({
    api_definition: Yup.object().shape({
      connection_key: Yup.string().required("Connection Key is required"),
    }),
  }),
});

export const addMultiGridSchema = Yup.object().shape({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Name is required"),
  value: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Value is required"),
});
export const resourceQuerySchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Query name is required"),
  query: Yup.string().required("Please enter query"),
  source: Yup.object().shape({
    resource_id: Yup.string().required("Resource is required"),
  }),
});
export const GenericResourceQuerySchema = Yup.object({
  ...resourceQuerySchema.fields,
  connection_key: Yup.number().required("Connection key is required"),
  linked_service_id: Yup.number().required("Connection Type is required"),
});
export const GenericResourceFormSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Query name is required"),
  code: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Code is required"),
  generic_research_query_tags: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least one Tag")
    .required("Please select Tag"),
  // description: Yup.string().required("Description is required"),
});

export const mixedQueryItemSchema = Yup.object({
  sub_type: Yup.string().required("Sub type is required"),

  should_require_resource_id: Yup.boolean().default(false),
  resource_id: Yup.mixed().when("should_require_resource_id", {
    is: true,
    then: (schema) =>
      schema
        .required("Resource is required")
        .typeError("Please select a valid resource"),
    otherwise: (schema) => schema.notRequired(),
  }),

  should_require_external_fields: Yup.boolean().default(false),
  linked_service_id: Yup.mixed().when("should_require_external_fields", {
    is: true,
    then: (schema) => schema.required("Connection Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  connection_key_id: Yup.mixed().when("should_require_external_fields", {
    is: true,
    then: (schema) => schema.required("Connection Key ID is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

// New schema specifically for Generic Mixed Query functionality
export const genericMixedQueryItemSchema = Yup.object({
  sub_type: Yup.string().required("Sub type is required"),

  // Validate data_pull_query when sub_type is selected
  data_pull_query: Yup.string().when("sub_type", {
    is: (value: string) => value && value !== "",
    then: (schema) => schema.required("Query is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  should_require_resource_id: Yup.boolean().default(false),
  resource_id: Yup.mixed().when("should_require_resource_id", {
    is: true,
    then: (schema) =>
      schema
        .required("Resource is required")
        .typeError("Please select a valid resource"),
    otherwise: (schema) => schema.notRequired(),
  }),

  should_require_external_fields: Yup.boolean().default(false),
  linked_service_id: Yup.mixed().when("should_require_external_fields", {
    is: true,
    then: (schema) => schema.required("Connection Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  connection_key_id: Yup.mixed().when("should_require_external_fields", {
    is: true,
    then: (schema) => schema.required("Connection Key ID is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  external_source_name: Yup.string().when("should_require_external_fields", {
    is: true,
    then: (schema) => schema.required("External source name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
export const genericExternalQuerySchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Query name is required"),
  query: Yup.string().required("Please enter query"),
  linked_service: Yup.object().required("Connection Type is required"),
  connection_key: Yup.object().required("Connection Key  is required"),
});

export const externalQuerySchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Query name is required"),
  query: Yup.string().required("Please enter query"),
  linked_service: Yup.object().required("Connection Type is required"),
  connection_key: Yup.object().required("Connection Key  is required"),
});

export const externalQueryFetchColumnsSchema = Yup.object({
  table_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Table name is required"),
  external_source_name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("External source name is required"),
});
export const externalGenericQueryFetchColumnsSchema = Yup.object({
  table_name: Yup.string().when("should_require_table_name", {
    is: true,
    then: (schema) =>
      schema.required("Cannot fetch columns without table name"),
    otherwise: (schema) => schema.notRequired(),
  }),
  external_source_name: Yup.string().when(
    "should_require_external_source_name",
    {
      is: true,
      then: (schema) => schema.required("External source name is required"),
      otherwise: (schema) => schema.notRequired(),
    },
  ),
  should_require_table_name: Yup.boolean().default(false),
  should_require_external_source_name: Yup.boolean().default(false),
});
export const mixedQueryFetchColumnsSchema = Yup.object({
  ...externalGenericQueryFetchColumnsSchema.fields,
});

export const mergeQuerySchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Query name is required"),
  query: Yup.string().required("Please enter query"),
});

// New schema specifically for Generic Mixed Query functionality
export const mixedQueryNewSchema = Yup.object({
  name: Yup.string()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest,
    )
    .required("Query name is required"),
  query: Yup.string()
    .required("Please enter query")
    .test("not-empty", "Please enter a valid query", function (value) {
      // Only reject completely empty queries, allow placeholders like "SELECT * FROM <>"
      return value?.trim() !== "";
    }),
});
export const getBlobListSchema = Yup.object({
  linked_service: Yup.object().required("Please select Connection Type"),
  connection_key: Yup.number().required("Please select Connection Key"),
  container_name: Yup.string().required("Please enter Container Name"),
  // file_name: Yup.string().required("Please enter File Name"),
  // file_path: Yup.string().required("Please enter File Path"),
});

export const getSftpListSchema = Yup.object({
  linked_service: Yup.object().required("Please select Connection Type"),
  connection_key: Yup.number().required("Please select Connection Key"),
  file_path: Yup.string(),
  file_name: Yup.string(),
});

export const secondaryMergeResourceSchema = Yup.object().shape({
  resource_id: Yup.number().required("Please select secondary resource"),
  merge_on: Yup.array()
    .of(Yup.string())
    .min(1, "Please select at least one resource column")
    .test(
      "no-blank-values",
      "Resource columns cannot be empty or contain 'blank'",
      (columns) => {
        return (
          Array.isArray(columns) && columns.every((col) => col?.trim() !== "")
        );
      },
    )
    .required("Please select resource columns"),
});

export const reRunBlobLinkedServiceSchema = Yup.object().shape({
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  linked_service: Yup.object().required("Connection Type is required"),
  connection_key: Yup.number().required("Connection Key is required"),
  container_name: Yup.string().required("Container Name is required"),
  resource_path: Yup.string().required("Resource Path is required"),
  column_delimiter: Yup.string().required("Column Delimiter is required"),
  file_name: Yup.string().required("File Name is required"),
  system_id: Yup.number().required("Please select system"),
  // excel_sheet_name: Yup.string(),
});
export const reRunLocalLinkedServiceSchema = Yup.object().shape({
  file_processing_id: Yup.string().required(
    "File Processing Attributes is required",
  ),
  linked_service: Yup.object().required("Connection Type is required"),
  resource_path: Yup.string().required("Resource Path is required"),
  connection_key: Yup.string().required("Connection Key is required"),
  column_delimiter: Yup.string().required("Column Delimiter is required"),
  file_name: Yup.string().required("File Name is required"),
  system_id: Yup.number().required("Please select system"),
  // excel_sheet_name: Yup.string(),
});

export const reRunSftpLinkedServiceSchema = Yup.object()
  .shape({
    file_processing_id: Yup.string().required(
      "File Processing Attributes is required",
    ),
    linked_service: Yup.object().required("Connection Type is required"),
    connection_key: Yup.number().required("Connection Key is required"),
    remote_directory: Yup.string(),
    resource_path: Yup.string(),
    column_delimiter: Yup.string().required("Column Delimiter is required"),
    file_name: Yup.string().required("File Name is required"),
    system_id: Yup.number().required("Please select system"),
    // excel_sheet_name: Yup.string(),
  })
  .test(
    "sftp-path-required",
    "Remote Directory or Resource Path is required",
    (value) => {
      const remoteDirectory = value?.remote_directory?.trim();
      const resourcePath = value?.resource_path?.trim();
      return Boolean(remoteDirectory || resourcePath);
    },
  );

export const reRunSqlLinkedServiceSchema = Yup.object().shape({
  linked_service: Yup.object().required("Connection Type is required"),
  connection_key: Yup.string().required("Connection Key is required"),
  sql_query: Yup.string()
    .required("SQL Query is required")
    .test(
      "contains-only-spaces",
      "SQL Query cannot contain only spaces",
      (value) => {
        if (value === "") {
          return true;
        } else {
          const containsOnlySpaces = !/\S/.test(value); // Check for only spaces
          return !containsOnlySpaces;
        }
      },
    ),
  system_id: Yup.number().required("Please select system"),
});

export const reRunBasicAuthApiDefinitionSchema = Yup.object({
  api_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    user_name: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
    url: Yup.string().required("Url is required"),
    request_timeout: Yup.string().required("Request Timeout is required"),
  }),
});

export const reRunTokenAuthApiDefinitionSchema = Yup.object({
  api_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    bearer_token: Yup.string().required("Bearer Token is required"),
    url: Yup.string().required("Url is required"),
    request_timeout: Yup.string().required("Request Timeout is required"),
  }),
});

export const reRunKeyAuthApiDefinitionSchema = Yup.object({
  api_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    api_key: Yup.string().required("Api Key is required"),
    url: Yup.string().required("Url is required"),
    request_timeout: Yup.string().required("Request Timeout is required"),
  }),
});

export const reRunOAuthApiDefinitionSchema = Yup.object({
  api_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    oauth_client_id: Yup.string().required("Oauth Client Id is required"),
    oauth_client_secret: Yup.string().required(
      "Oauth Client Secret is required",
    ),
    oauth_url: Yup.string().required("Oauth Url is required"),
    url: Yup.string().required("Url is required"),
    request_timeout: Yup.string().required("Request Timeout is required"),
  }),
});
export const reRunNoAuthApiDefinitionSchema = Yup.object({
  api_definition: Yup.object().shape({
    connection_key: Yup.string().required("Connection Key is required"),
    url: Yup.string().required("Url is required"),
    request_timeout: Yup.string().required("Request Timeout is required"),
  }),
});

export const comparisonResearchQuerySchema = Yup.object({
  rule_id: Yup.number().required("Rule is required"),
});

// ─── Scoring Schemas ───

const impactSumNotExceedingOne = function (this: Yup.TestContext): boolean {
  const record = Number((this.parent as any)?.impact_of_record_level);
  const issue = Number((this.parent as any)?.impact_of_issue_level);
  // Let Yup's type/required validators report missing or non-numeric values.
  if (!Number.isFinite(record) || !Number.isFinite(issue)) return true;
  return record + issue <= 1 + 1e-9;
};

export const validationScoringConfigFormSchema = Yup.object({
  impact_of_record_level: Yup.number()
    .min(0, "Impact of record level must be between 0 and 1")
    .max(1, "Impact of record level must be between 0 and 1")
    .required("Impact of record level is required")
    .test("impact-sum-max", IMPACT_SUM_MAX_MESSAGE, impactSumNotExceedingOne),
  impact_of_issue_level: Yup.number()
    .min(0, "Impact of issue level must be between 0 and 1")
    .max(1, "Impact of issue level must be between 0 and 1")
    .required("Impact of issue level is required")
    .test("impact-sum-max", IMPACT_SUM_MAX_MESSAGE, impactSumNotExceedingOne),
  factor_low: Yup.number()
    .min(0, "Low factor must be between 0 and 1")
    .max(1, "Low factor must not exceed 1")
    .required("Low factor is required"),
  factor_medium: Yup.number()
    .min(0, "Medium factor must be between 0 and 1")
    .max(1, "Medium factor must not exceed 1")
    .required("Medium factor is required"),
  factor_high: Yup.number()
    .min(0, "High factor must be between 0 and 1")
    .max(1, "High factor must not exceed 1")
    .required("High factor is required"),
  comment: Yup.string(),
});

// Generic RQ and Validation scoring have the same canonical numeric rules.
export const genericResearchQueryScoringSchema =
  validationScoringConfigFormSchema.omit(["comment"]);

export const comparisonScoringConfigFormSchema = Yup.object({
  blend_ratio: Yup.number()
    .min(0, "Blend ratio must be between 0 and 1")
    .max(1, "Blend ratio must be between 0 and 1")
    .required("Blend ratio is required"),
  category_weight_missing: Yup.number()
    .min(0, "Weight must be between 0 and 1")
    .max(1, "Weight must be between 0 and 1")
    .required("Missing weight is required"),
  category_weight_mismatch: Yup.number()
    .min(0, "Weight must be between 0 and 1")
    .max(1, "Weight must be between 0 and 1")
    .required("Mismatch weight is required"),
  category_weight_validation: Yup.number()
    .min(0, "Weight must be between 0 and 1")
    .max(1, "Weight must be between 0 and 1")
    .required("Validation weight is required"),
  // An amplification multiplier (system default 3.0), not a severity factor.
  missing_factor: Yup.number()
    .min(0, "Missing factor must be non-negative")
    .required("Missing factor is required"),
  mismatch_factor_low: Yup.number()
    .min(0, "Low mismatch factor must be between 0 and 1")
    .max(1, "Low mismatch factor must not exceed 1")
    .required("Low mismatch factor is required"),
  mismatch_factor_medium: Yup.number()
    .min(0, "Medium mismatch factor must be between 0 and 1")
    .max(1, "Medium mismatch factor must not exceed 1")
    .required("Medium mismatch factor is required"),
  mismatch_factor_high: Yup.number()
    .min(0, "High mismatch factor must be between 0 and 1")
    .max(1, "High mismatch factor must not exceed 1")
    .required("High mismatch factor is required"),
  custom_factor_sql: Yup.string().nullable(),
  custom_factor_target: Yup.string()
    .nullable()
    .oneOf(
      [null, "", "missing", "mismatch_low", "mismatch_medium", "mismatch_high"],
      "Invalid target",
    ),
  comment: Yup.string(),
});

export const runScoringConfigFormSchema = Yup.object({
  severity: Yup.string()
    .oneOf(["low", "medium", "high"], "Severity must be low, medium, or high")
    .required("Severity is required"),
  factor: Yup.number()
    .moreThan(0, "Factor must be positive")
    .max(1, "Factor must not exceed 1")
    .required("Factor is required"),
});

export const pipelineWeightConfigFormSchema = Yup.object({
  comparison_weight: Yup.number()
    .min(0, "Weight must be non-negative")
    .required("Comparison weight is required"),
  validation_weight: Yup.number()
    .min(0, "Weight must be non-negative")
    .required("Validation weight is required"),
  research_query_weight: Yup.number()
    .min(0, "Weight must be non-negative")
    .required("Research query weight is required"),
});
